import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { ChipStyled } from './styled';
import { SxProps } from '@mui/material';

type Props = {
  label: string;
  onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  sx?: SxProps;
};

export const Chip = ({ label, onClick, sx }: Props) => {
  return (
    <ChipStyled
      label={label}
      onClick={onClick}
      onDelete={onClick}
      deleteIcon={<CloseIcon />}
      sx={sx}
    />
  );
};
